import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import React from "react";
import { Skeleton } from "primereact/skeleton";
import { useNavigate } from "react-router-dom";
import EmptyDataView from "~/components/nodataview";
import usersIcon from "../../../assets/images/users-icons.png";

const UserListTable = ({
  users,
  loading,
  page,
  rows,
  totalRecords,
  onPageChange,
  handleOpenDialog,
  isDataAvailable,
}) => {
  const navigate = useNavigate();
  const skeletonRows = [...Array(5)];
  const role = {
    GXM_ADMIN: "GXM Admin",
    CUSTOMER: "Customer User",
    LSP_USER: "LSP User",
    GXM_USER: "GXM User",
    GXM_MANAGER: "GXM Manager",
    LSP_MANAGER: "LSP Manager",
    CUSTOMER_MANAGER: "Customer Manager",
  };

  const processUserAccessData = (data) => {
    const serviceCount = {};
    let entityCount = 0;

    data.access.forEach((item) => {
      if (item.entity) {
        entityCount++;
      }
      item.services.forEach((service) => {
        const name = service.name;
        serviceCount[name] = (serviceCount[name] || 0) + 1;
      });
    });

    const summaryString = Object.entries(serviceCount)
      .map(([name, count]) => `${name} (${count})`)
      .join(", ");

    return {
      entityCount:
        entityCount > 1 ? `${entityCount} Entities` : `${entityCount} Entity`,
      summaryString,
    };
  };

  return (
    <div>
      {isDataAvailable ? (
        <DataTable
          value={loading ? skeletonRows : users}
          className="datatable-right-align"
          lazy
          paginator={totalRecords > 10}
          first={page * rows}
          rows={rows}
          totalRecords={totalRecords}
          onPage={onPageChange}
          rowsPerPageOptions={[10, 20, 30]}
          emptyMessage="No user found"
        >
          <Column
            header="Name"
            body={(data) =>
              loading ? (
                <Skeleton width="100%" />
              ) : (
                <span>
                  {data?.first_name} {data?.last_name}
                </span>
              )
            }
          />
          <Column
            header="Email"
            body={(data) => (loading ? <Skeleton width="100%" /> : data.email)}
          />
          <Column
            header="Entities"
            body={(data) =>
              loading ? (
                <Skeleton width="100%" />
              ) : (
                processUserAccessData(data).entityCount
              )
            }
          />
          <Column
            header="Services"
            body={(data) =>
              loading ? (
                <Skeleton width="100%" />
              ) : (
                processUserAccessData(data).summaryString || "0 Service Lines"
              )
            }
          />
          <Column
            header="User Role"
            className="user__role--col"
            style={{ minWidth: "164px" }}
            body={(data) =>
              loading ? <Skeleton width="100%" /> : role[data.role]
            }
          />
          <Column
            className="user_action--col"
            body={(data) =>
              loading ? (
                <Skeleton width="100%" />
              ) : (
                <>
                  <span
                    className="pi pi-pencil ml-4 mr-3 pencil-pointer"
                    onClick={() => navigate(`${data.id}/user-info`)}
                  />
                  <span
                    className="pi pi-trash pencil-pointer"
                    onClick={() => handleOpenDialog(data)}
                  ></span>
                </>
              )
            }
          />
        </DataTable>
      ) : (
        <div className="flex flex-column justify-content-center align-items-center p-5">
          <EmptyDataView
            Icon={
              <img
                className="users-card-icon-img"
                src={usersIcon}
                alt="Users Icon"
              />
            }
            Header="No users found"
            Description="If you expect users to appear, ensure they have been added to the system or adjust your search filters."
          />
        </div>
      )}
    </div>
  );
};

export default UserListTable;
